import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { API_BASE_URL } from '../constants/api';

export const cartApi = createApi({
  reducerPath: 'cartApi',
  baseQuery: createAuthBaseQuery(API_BASE_URL),
  tagTypes: ['Cart'],
  endpoints: (builder) => ({
    getCart: builder.query({
      query: () => '/cart',
      providesTags: ['Cart'],
    }),
    addCartItem: builder.mutation({
      query: (item) => ({ url: '/cart/items', method: 'POST', body: item }),
      invalidatesTags: ['Cart'],
    }),
    removeCartItem: builder.mutation({
      query: ({ item_id, item_type }) => ({
        url: `/cart/items/${encodeURIComponent(item_type)}/${encodeURIComponent(item_id)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Cart'],
    }),
    clearCart: builder.mutation({
      query: () => ({ url: '/cart', method: 'DELETE' }),
      invalidatesTags: ['Cart'],
    }),
    mergeCart: builder.mutation({
      query: (items) => ({ url: '/cart/merge', method: 'POST', body: { items } }),
      invalidatesTags: ['Cart'],
    }),
  }),
});

export const {
  useGetCartQuery,
  useAddCartItemMutation,
  useRemoveCartItemMutation,
  useClearCartMutation,
  useMergeCartMutation,
} = cartApi;
